import React from 'react';
import styles from './Menu.module.css';

const DontHave = () => {

  return (
    <div className={styles.mainMenu}>
      <div className={styles.dontHave}>
        안먹어요
      </div>
    </div>
  );
}

export default DontHave;